/**
 * ラベルと値の連結（サンプル UI 共通）。
 * 保管経路・操作名などと同じく中黒 ` · ` で区切る。
 */
export function joinLabeledValue(label: string, value: string): string {
  const l = label.trim();
  const v = value.trim();
  if (!v) return l;
  if (!l) return v;
  return `${l} · ${v}`;
}
